import React, { FC } from 'react';
import { IonReorderProps } from '../../common/components.types';
import { IonReorder } from '@ionic/react';

export const AllieReorder: FC<IonReorderProps> = (props) => {
  return <IonReorder {...props} />;
};
